// Import membership flow functionality
import '../../assets/javascripts/membership_flow';
